module.exports = __webpack_public_path__ + "cd455783/img/search-filter-icon.c4751a52.svg";